export namespace PROPOSAL_TYPE {
    export const QUOTE = "quote"
    export const ORDER = "order"
    export const INVOICE = "invoice"
    export const ACCOUNT_STATEMENT = "account-statement"
    export const PACKING_SLIP = "packing-slip"
    export const PRICE_LIST = "price-list"
    export const CONTRACT = "contract"
    export const SCHEDULING_PAGE = "scheduling-page"
    export const CREDIT_MEMO_RECEIPT = "credit-memo"
    export const STOCK_DOCUMENT = "stock-document"
}

export type PROPOSAL_TYPE = typeof PROPOSAL_TYPE[keyof typeof PROPOSAL_TYPE]



// WEBPACK FOOTER //
// ./src/state/proposal/ProposalType.ts